import {
  imageIdFormat,
  shopifyListingIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const updateListingImages = {
  name: "updateListingImages" as const,
  input: z.object({
    shopifyListingId: shopifyListingIdFormat.schema,
    images: z.array(
      z.object({
        productFamilyImageId: imageIdFormat.schema.optional(),
        productImageId: imageIdFormat.schema.optional(),
        position: z.number(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
